import { BaseCriteriaModel } from './base-criteria.model';

export class FinancialItemPricingListingQueryCriteriaModel extends BaseCriteriaModel {
  // extension of BaseCriteriaModel
  snapshot?: string;
  search_word?: string;

  // for multiple
  guids?: string[];
  coupon_hdr_guids?: string[];
  cashbook_guids?: string[];
  comp_guids?: string[];
  membership_class_guids?: string[];
  pricing_scheme_hdr_guids?: string[];
  label_hdr_guids?: string[];
  label_hdr_1_guids?: string[];
  label_hdr_2_guids?: string[];
  label_hdr_3_guids?: string[];
  label_hdr_4_guids?: string[];
  label_hdr_5_guids?: string[];
  label_hdr_6_guids?: string[];
  label_hdr_7_guids?: string[];
  label_hdr_8_guids?: string[];
  label_hdr_9_guids?: string[];
  label_hdr_10_guids?: string[];
  label_hdr_11_guids?: string[];

  //for the header(s)
  code?: string;
  name?: string;
  category?: string;
  txn_type?: string;
  client_key?: string;
  client_source?: string;
  dim_width_from?: number;
  dim_width_to?: number;
  dim_height_from?: number;
  dim_height_to?: number;
  dim_length_from?: number;
  dim_length_to?: number;
  dim_weight_from?: number;
  dim_weight_to?: number;
  txn_class?: string;
  consignment_flg?: boolean;
  client_value?: string;
  tax_country?: string;
  input_tax_type?: string;
  input_tax_code?: string;
  output_tax_type?: string;
  output_tax_code?: string;
  output_wht_tax_type?: string;
  output_wht_tax_code?: string;
  cfg_delivery?: string;
  cfg_production?: string;
  sub_item_type?: string;
  ccy_code?: string;
  pricing_logic?: string;
  valid_date_start_from?: string;
  valid_date_start_to?: string;
  valid_date_end_from?: string;
  valid_date_end_to?: string;

  //for the line(s)
  line_code?: string;
  line_name?: string;
  line_txn_type?: string;
  line_guid?: string;
  line_client_key?: string;
  line_client_source?: string;
  line_item_hdr_guid?: string;
  line_dim_width?: number;
  line_dim_height?: number;
  line_dim_length?: number;
  line_dim_weight?: number;
  mkt_guid?: string;
  mkt_item_id?: string;
  hdr_guid?: string;
}